import { FullConversationTagSchema } from "@redotech/redo-model/conversation/conversation-schema-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getTagsByTagGroup = {
  name: "getTagsByTagGroup" as const,
  input: z.object({ tagGroupId: zExt.objectId() }),
  output: z.object({ tags: z.array(FullConversationTagSchema) }),
};
